import axios from "axios";
import Config from "../utils/Config";

class ReportService
{
    config = {
        headers: {
          Authorization: "",
          GroupId: "",
          CompanyId: "",
        },
      };
    
      setAccessToken(accessToken, groupId, companyId) {
        this.config.headers.Authorization = accessToken;
        this.config.headers.GroupId = groupId;
        this.config.headers.CompanyId = companyId;
      }

      async GetDataforDocumentSumeryReport (accessToken, groupId, companyId){
        this.setAccessToken(accessToken, groupId, companyId);
            const data = await axios.get(
                Config.BACKEND_URL + `/api/docMogu/documentsSummeryReport?companyId=${companyId}&groupId=${groupId}`,
                this.config
            )
           //console.log("Return Data "+ JSON.stringify(data));
            return data.data;
      }

      async GetDataforTotalTaxAmountReport (accessToken, groupId, companyId)
      {
        this.setAccessToken(accessToken,groupId,companyId);
        const data = await axios.get(
          Config.BACKEND_URL + `/api/docMogu/taxAmountReport?companyId=${companyId}&groupId=${groupId}`,
          this.config
      )
    //  console.log("Return Data "+ Config.BACKEND_URL + `/api/docMogu/invoicesAndExtractedData?companyId=${companyId}&documentType=Accounts receivable`);
      return data.data;
      }

      async getSupplierInformation (accessToken, groupId, companyId)
      {
        this.setAccessToken(accessToken, groupId, companyId);
        const data = await axios.get(
          Config.BACKEND_URL + `/api/docMogu/reportsSupplierDropDown?groupId=${groupId}`,
          this.config
        )
        return data.data;
      }

      async getBuyerInformation (accessToken, groupId, companyId)
      {
        this.setAccessToken(accessToken, groupId, companyId);
        const data = await axios.get(
          Config.BACKEND_URL + `/api/docMogu/reportsBuyerDropDown?groupId=${groupId}`,
          this.config
        )
        return data.data;
      }
      async GetInvoiceSharingDetails (accessToken,groupId, companyId, formData)
      {
        this.setAccessToken(accessToken, groupId, companyId);
        const data = await axios.post(
          Config.BACKEND_URL + "/api/docMogu/share-option-files", //api/company
          formData,
          this.config
        )
        return data.data;
      }
      async shareInvoiceDetails (accessToken,groupId, companyId, formData)
      {
        this.setAccessToken(accessToken, groupId, companyId);
        const data = await axios.post(
          Config.BACKEND_URL + "/api/docMogu/invoiceShare", //api/company
          formData,
          this.config
        )
        console.log("Sharing",JSON.stringify(data.data));
        return data.data;
      }
}

export default new ReportService();